import { OrderedItemStatus } from './OrderedItemStatus.model';
import { TestResult } from './TestResult.model';

export class Test {
  testName!: string;
  testCode!: string;
  results: TestResult[] = [];
  summary!: string | null;
  itemStatus?: OrderedItemStatus;
}
